/** Max favorites a user can pin (guards the array from unbounded growth). */
export const MAX_FAVORITES = 200;

/** Pure toggle: add the id if absent (up to the cap), else remove it. */
export function toggleFavorite(list: string[], id: string): string[] {
  if (list.includes(id)) return list.filter((x) => x !== id);
  if (list.length >= MAX_FAVORITES) return list;
  return [...list, id];
}
